// @ts-nocheck
/* eslint-disable */
export const docDownloadIcon = {
    data: ``,
    name: 'doc-download' as const
};